import { PRODUCTS } from "@/constants/testIds";
import { Sparkles, Clock } from "lucide-react";

const LAUNCH_IMG =
  "https://customer-assets.emergentagent.com/job_cashew-origin-story/artifacts/1zbiqz4p_ChatGPT%20Image%2011.%20Juni%202026%2C%2015_56_57.png";

const FUTURE = [
  {
    name: "Honey Gold",
    tagline: "Sun-touched sweetness.",
    description:
      "Glazed with Nigerian forest honey and slow-toasted to a soft amber finish. A premium sweet-savoury indulgence.",
    accent: "#c5a059",
    chip: "Coming Soon",
    image:
      "https://static.prod-images.emergentagent.com/jobs/096b6207-302a-4d30-852c-60e212c167c7/images/8aaa11081405b82ebb73a9a6c7db68f93f5023b0c3c060be860b5fa0368bfa3d.png",
  },
  {
    name: "Jollof Spice",
    tagline: "Lagos in every bite.",
    description:
      "Inspired by Nigeria's national dish — smoked paprika, tomato, scotch bonnet warmth and a whisper of thyme.",
    accent: "#c86b5e",
    chip: "Coming Soon",
    image:
      "https://static.prod-images.emergentagent.com/jobs/096b6207-302a-4d30-852c-60e212c167c7/images/eb9bbdff2920db7857156daa3e9dd17c9269fdc21e1153df76745aaccafc9e1c.png",
  },
];

export const Products = () => {
  return (
    <section
      id="products"
      data-testid={PRODUCTS.wrapper}
      className="relative py-24 sm:py-32 bg-[#fdfaf4]"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6 mb-14">
          <div className="max-w-2xl">
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-10 bg-[#c5a059]" />
              <span className="overline">The Collection</span>
            </div>
            <h2 className="font-serif-display text-[40px] sm:text-[56px] leading-[1.05] text-[#1a3626] tracking-tight">
              One launch pouch. <br className="hidden sm:block" />
              <em className="italic text-[#8b5a2b]">Two flavors to follow.</em>
            </h2>
          </div>
          <p className="text-[14px] sm:text-[15px] text-[#5c4033] max-w-sm leading-relaxed">
            Our debut is the kernel in its purest form. Honey Gold and Jollof
            Spice arrive next — small batches, in turn.
          </p>
        </div>

        {/* Launch product — hero card */}
        <article
          data-testid={PRODUCTS.launchCard}
          className="relative bg-white rounded-[2.5rem] overflow-hidden shadow-[0_18px_60px_rgba(26,54,38,0.1)] grid lg:grid-cols-2"
        >
          <div className="relative min-h-[360px] lg:min-h-[520px] bg-[#faf7f2] overflow-hidden flex items-center justify-center">
            <img
              src={LAUNCH_IMG}
              alt="NAIJA Premium Cashews 250g stand-up pouch"
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute top-5 left-5 inline-flex items-center gap-2 bg-[#1a3626] text-[#faf7f2] rounded-full px-4 py-2 text-[10.5px] uppercase tracking-[0.22em]">
              <Sparkles size={12} className="text-[#c5a059]" />
              Launch Product
            </div>
          </div>

          <div className="p-8 sm:p-12 lg:p-14 flex flex-col justify-center">
            <div className="text-[11px] uppercase tracking-[0.24em] text-[#8b5a2b]">
              The Original
            </div>
            <h3 className="mt-3 font-serif-display text-[34px] sm:text-[42px] text-[#1a3626] tracking-tight leading-[1.05]">
              NAIJA Premium <br className="hidden sm:block" />
              <em className="italic">Cashews 250g</em>
            </h3>
            <p className="mt-5 text-[15px] sm:text-[16px] leading-[1.75] text-[#5c4033] max-w-lg">
              Single-origin Nigerian cashews, slow-roasted with a whisper of
              sea salt. Buttery, balanced and unmistakably ours — the kernel,
              honoured.
            </p>

            <ul className="mt-7 grid grid-cols-2 gap-3 text-[12.5px] text-[#1a3626]">
              {[
                ["Origin", "Imo & Abia, NG"],
                ["Weight", "250 g · Stand-Up Pouch"],
                ["Roast", "Slow, small batch"],
                ["Additives", "None. Ever."],
              ].map(([k, v], i) => (
                <li
                  key={i}
                  className="flex flex-col gap-0.5 rounded-2xl bg-[#fdfaf4] border border-[#c5a059]/20 px-4 py-3"
                >
                  <span className="text-[10px] uppercase tracking-[0.22em] text-[#8b5a2b]">
                    {k}
                  </span>
                  <span className="font-medium">{v}</span>
                </li>
              ))}
            </ul>

            <div className="mt-8 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-5">
              <div>
                <div className="text-[10.5px] uppercase tracking-[0.22em] text-[#8b5a2b]">
                  Founder Pricing
                </div>
                <div className="font-serif-display text-[32px] text-[#1a3626] leading-none mt-1">
                  €6.99
                </div>
              </div>
              <a
                data-testid={PRODUCTS.launchCta}
                href="#signup"
                className="inline-flex items-center justify-center gap-2 bg-[#1a3626] text-[#faf7f2] rounded-full px-7 py-4 text-[13.5px] font-medium hover:bg-[#12261b] transition-all duration-300 shadow-[0_10px_30px_rgba(26,54,38,0.22)]"
              >
                Reserve Your Pouch
                <span className="text-[#c5a059]">→</span>
              </a>
            </div>
          </div>
        </article>

        {/* Future flavors */}
        <div className="mt-12 sm:mt-16">
          <div className="flex items-center gap-3 mb-7">
            <span className="h-px w-10 bg-[#c5a059]" />
            <span className="overline">Future Flavors</span>
          </div>

          <div className="grid md:grid-cols-2 gap-6 lg:gap-8">
            {FUTURE.map((p, i) => (
              <article
                key={i}
                data-testid={PRODUCTS.futureCard(i)}
                className="group relative bg-white rounded-[2rem] overflow-hidden shadow-[0_10px_40px_rgba(26,54,38,0.06)] hover:shadow-[0_24px_60px_rgba(26,54,38,0.14)] hover:-translate-y-2 transition-all duration-500 flex flex-col"
              >
                <div className="relative aspect-[16/10] overflow-hidden bg-[#faf7f2]">
                  <img
                    src={p.image}
                    alt={p.name}
                    className="w-full h-full object-cover transition-transform duration-[1200ms] group-hover:scale-110 opacity-95"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#1a3626]/30 to-transparent" />
                  <div className="absolute top-4 left-4 inline-flex items-center gap-2 bg-[#faf7f2]/95 backdrop-blur rounded-full px-3 py-1.5 text-[10px] uppercase tracking-[0.22em] text-[#1a3626]">
                    <Clock size={11} />
                    {p.chip}
                  </div>
                </div>

                <div className="p-7 lg:p-8 flex flex-col flex-1">
                  <div className="text-[11px] uppercase tracking-[0.22em] text-[#8b5a2b]">
                    {p.tagline}
                  </div>
                  <h3 className="mt-2 font-serif-display text-[28px] text-[#1a3626] tracking-tight">
                    {p.name}
                  </h3>
                  <p className="mt-3 text-[14.5px] leading-[1.7] text-[#5c4033] flex-1">
                    {p.description}
                  </p>

                  <div className="mt-6 gold-hairline-solid" />
                  <div className="mt-5 flex items-center justify-between">
                    <div className="text-[11.5px] uppercase tracking-[0.22em] text-[#8b5a2b]">
                      Drops after launch
                    </div>
                    <a
                      href="#signup"
                      className="inline-flex items-center gap-2 text-[12.5px] font-medium text-[#1a3626] border border-[#1a3626]/20 hover:border-[#1a3626] rounded-full px-4 py-2.5 transition-colors"
                    >
                      Notify me →
                    </a>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
